import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "t-muted" }
const _hoisted_2 = { class: "t-highlight" }
const _hoisted_3 = {
  key: 0,
  class: "ticket-private-note t-muted"
}
const _hoisted_4 = { class: "list-unstyled" }
const _hoisted_5 = ["href"]

import { computed } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { dateTime } from '@/core/date';
import { TicketComment } from '@/modules/ticket/TicketComment';
import FaIcon from '@/core/components/FaIcon.vue';

interface TicketViewCommentProps {
	comment: TicketComment;
	ticketId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketViewComment',
  props: {
    comment: {},
    ticketId: {}
  },
  setup(__props: any) {

const { $gettext } = useGettext();
const props = __props;
const authorName = computed(() => {
	if (!props.comment.user) {
		return $gettext('Rapportören');
	}
	return props.comment.user.name;
});

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["ticket-comment", {
			'is-private': props.comment.private,
		}])
  }, [
    _createElementVNode("time", _hoisted_1, _toDisplayString(_unref(dateTime)(props.comment.created_time)), 1),
    _createElementVNode("h4", _hoisted_2, [
      _createTextVNode(_toDisplayString(authorName.value) + ": ", 1),
      (props.comment.private)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createTextVNode(" ("),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [
                _createTextVNode("Privat anteckning")
              ]),
              _: 1
            }),
            _createTextVNode(") ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", null, _toDisplayString(props.comment.message), 1),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.comment.attachments, (attachment) => {
        return (_openBlock(), _createElementBlock("li", {
          key: attachment.id
        }, [
          _createElementVNode("a", {
            href: `/api/ticket/${props.ticketId}/comment/${props.comment.id}/attachment/${attachment.id}`
          }, [
            _createVNode(FaIcon, { icon: "paperclip" }),
            _createTextVNode(" " + _toDisplayString(attachment.file_name), 1)
          ], 8, _hoisted_5)
        ]))
      }), 128))
    ])
  ], 2))
}
}

})